/**
 * @name SortHeadr.js
 * @author 김권영
 * @since 2025. 01. 06.
 * @description
 * 특정 필드에 대한 정렬 가능한 <th> 컴포넌트
 * 
 * @param {string} field - 실제 정렬할 필드명 (예: "title", "regDate", "viewCount")
 * @param {string} label - 화면에 표시할 텍스트 (예: "제목", "등록일", "조회수")
 */
import React from 'react';
import { useSortingParams } from '@hooks';
import { FaSort, FaSortUp, FaSortDown } from 'react-icons/fa';
export default function SortHeader({ field, label, style: styleProp }) {
  const { sortField, sortOrder, handleSortClick } = useSortingParams();

  const isActive = (sortField === field);
  const ArrowIcon = isActive
    ? sortOrder === 'ASC'
      ? FaSortUp
      : FaSortDown
    : FaSort;

  return (
    <th onClick={() => handleSortClick(field)} style={{ cursor: 'pointer', whiteSpace: 'nowrap', ...styleProp }}>
      {label}&nbsp;<ArrowIcon style={{ display: 'inline', verticalAlign: 'middle', flexShrink: 0 }} />
    </th>
  );
}
